// Data Index - exports all landing page variants

import * as koelnData from './mock-koeln';
import * as allgemeinData from './mock-allgemein';
import * as dhiData from './mock-dhi';
import * as bartData from './mock-bart';
import * as augenbrauenData from './mock-augenbrauen';

export const landingPageVariants = {
  koeln: koelnData,
  allgemein: allgemeinData,
  dhi: dhiData,
  bart: bartData,
  augenbrauen: augenbrauenData,
};

export const getVariantData = (variant) => {
  return landingPageVariants[variant] || landingPageVariants.allgemein;
};

export const variantList = [
  { key: 'koeln', label: 'Köln', path: '/koeln' },
  { key: 'allgemein', label: 'Allgemein', path: '/' },
  { key: 'dhi', label: 'DHI Ohne Rasur', path: '/dhi' },
  { key: 'bart', label: 'Barttransplantation', path: '/bart' },
  { key: 'augenbrauen', label: 'Augenbrauen', path: '/augenbrauen' },
];

export default landingPageVariants;
